export async function fetchPositions() {
  const resp = await fetch("/api/positions");
  const json = await resp.json().catch(() => null);
  if (
    json &&
    typeof json === "object" &&
    ("status" in json || "message" in json)
  ) {
    return json;
  }
  return {
    status: resp.ok ? 200 : resp.status || 500,
    message: json?.message || (resp.ok ? "OK" : "Request failed"),
    data: json?.data ?? json,
    error: json?.error ?? null,
  };
}

export async function submitApplication(formData) {
  const resp = await fetch("/api/upload", {
    method: "POST",
    body: formData,
  });
  const json = await resp.json().catch(() => null);
  if (
    json &&
    typeof json === "object" &&
    ("status" in json || "message" in json)
  ) {
    return json;
  }
  return {
    status: resp.ok ? 201 : resp.status || 500,
    message:
      json?.message || (resp.ok ? "Application submitted" : "Upload failed"),
    data: json?.data ?? json,
    error: json?.error ?? null,
  };
}
